module.exports = __webpack_public_path__ + "img/error.427bdbbb.png";